import React, { ReactElement } from "react";
import Styles from "./CardTitleImage_SA.module.scss";
import classnames from "classnames";

interface CardTitleImageProps {
    title: string,
    content: string,
    classNameStyle: string,
    image: ReactElement
}
const CardTitleImage: React.FC<CardTitleImageProps> = (props: CardTitleImageProps) => {
    const { title, image, content, classNameStyle } = props;
    return (
        <div className={ classNameStyle }>
            <div className={classnames("card h-100", Styles.body)}>
                <div className={classnames(Styles.header, " card-header")}>
                    {image}
                </div>
                <div className= "card-body">
                    <h5 className={Styles.title}>{title}</h5>
                    <div className={classnames(Styles.content, Styles.align,"card-text")}>{content}</div>
                </div>
            </div>
        </div>
  );
};

export default CardTitleImage;